import type { ByteReader, GridId } from '@core/core/types'
import { assert } from 'common/helpers'
import type { ProjectId } from 'common/types'

import type { HttpResponse } from './__generated__/http-client'
import { getClient } from './helpers'

export const getFileNameGridFromProjectToIRAPApi = (
  projectId: ProjectId,
  gridId: GridId,
): Promise<string> => {
  const client = getClient('GridExportClient')
  return client.gridExportGetGridFromProjectIrapFileName(projectId, gridId).then(unfoldT)
}

export const downloadExportGridFromProjectToIRAPApi = (
  projectId: ProjectId,
  gridId: GridId,
): Promise<ByteReader> => {
  const client = getClient('GridExportClient')
  return client
    .gridExportExportGridFromProjectToIrap(projectId, gridId)
    .then(convertResponseToReader)
}

export const getFileNamePolygonFromProjectToIRAPApi = (
  projectId: ProjectId,
  gridId: GridId,
): Promise<string> => {
  const client = getClient('PolygonExportClient')
  return client.polygonExportGetProjectPolygonIrapFileName(projectId, gridId).then(unfoldT)
}

export const downloadExportPolygonFromProjectToIRAPApi = (
  projectId: ProjectId,
  gridId: GridId,
): Promise<ByteReader> => {
  const client = getClient('PolygonExportClient')
  return client
    .polygonExportExportPolygonFromProjectToIrap(projectId, gridId)
    .then(convertResponseToReader)
}

const convertResponseToReader = (response: HttpResponse<File>): ByteReader => {
  const reader = response.body
  assert(reader != null)
  return reader
}

const unfoldT = <T>(response: HttpResponse<T>): T => response.data
